import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import THEME from 'theme';
import { Heading, Text } from 'components/chroma';

const YouAreCoveredWrapper = styled.div`
  padding: 1rem 1rem 0;
  text-align: center;
  background-color: ${THEME.BACKGROUND.CARD};
`;

const getCongratulationsMessage = (payment?: boolean): string =>
  `Congratulations your ${
    payment ? 'payment' : 'application'
  } has been successful.`;

const YouAreCovered: FunctionComponent<{
  Image: FunctionComponent;
  payment?: boolean;
}> = ({ Image, payment }) => (
  <>
    <YouAreCoveredWrapper>
      <Heading size={1} margin={{ bottom: 1 }}>
        We&#39;ve got you covered.
      </Heading>
      <Text>{getCongratulationsMessage(payment)}</Text>
      <Image />
    </YouAreCoveredWrapper>
  </>
);

export default YouAreCovered;
